import { SAML_LOGOUT_URL, SAML_REDIRECT_URI, COGNITO_CLIENT_ID } from "../environment";

/** Set before IdP redirect; consumed on /login after SAML success so default Navigate(to dashboard) is preempted when needed. */
export const POST_LOGIN_REDIRECT_KEY = "post_login_redirect";

export function isSAMLLogin() {
    // Check localStorage flag (set during SAML login)
    // localStorage persists across sessions and tabs, cleared on logout
    const samlFlag = localStorage.getItem("saml_login");
    
    if (samlFlag === "true") {
        return true;
    }
    
    // Fallback: Try to check cookies (won't work if HttpOnly, but doesn't hurt to try)
    const cookies = document.cookie.split(';');
    const hasCognitoCookie = cookies.some(cookie => {
        const trimmed = cookie.trim();
        return trimmed.toLowerCase().startsWith('cognito=');
    });
    
    if (hasCognitoCookie) {
        localStorage.setItem("saml_login", "true");
        return true;
    }
    
    return false;
}

export function triggerBackgroundSamlLogout() {
    if (!SAML_LOGOUT_URL || !SAML_REDIRECT_URI || !COGNITO_CLIENT_ID) {
        console.warn('SAML logout skipped: Missing environment variables', {
            SAML_LOGOUT_URL: !!SAML_LOGOUT_URL,
            SAML_REDIRECT_URI: !!SAML_REDIRECT_URI,
            COGNITO_CLIENT_ID: !!COGNITO_CLIENT_ID
        });
        return;
    }

    const url =
        `${SAML_LOGOUT_URL}?client_id=${encodeURIComponent(COGNITO_CLIENT_ID)}` +
        `&logout_uri=${encodeURIComponent(SAML_REDIRECT_URI)}`;

    console.log('Triggering Cognito logout:', url);

    // ✅ Redirect in the SAME tab
    window.location.href = url;
}

